<template>
    <section class="p-3 bg-white border-light mt-3">
        <a
            class="font-weight-bold float-right "
            :class="canEditStaff ? 'text-primary cursor-pointer' : 'text-muted cursor-not-allowed'"
            @click="canEditStaff ? editProfile() : null"
            >Edit</a
        >
        <h5 class="mb-3 text-uppercase font-weight-bold">Clinic information</h5>

        <div class="d-flex flex-column justify-content-center">
            <p class="mb-0">
                <span class="font-weight-bold">Title: </span>
                <span class="comma-list" v-for="t in therapist.therapist_types">{{ t.title }}</span>
            </p>
            <p class="mb-0">
                <span class="font-weight-bold">Employee number: </span>
                <span>{{ therapist.employee_number }}</span>
            </p>
            <p class="mb-0">
                <span class="font-weight-bold">NPI number: </span>
                <span>{{ therapist.npi_number }}</span>
            </p>
            <p class="mb-0">
                <span class="font-weight-bold">Department: </span>
                <span class="comma-list" v-for="t in therapist.therapist_types">{{
                    t.department
                }}</span>
            </p>
            <p class="mb-0">
                <span class="font-weight-bold">Supervisor: </span>
                <span>{{ therapist.supervisor_user ? therapist.supervisor_user.name : "" }}</span>
            </p>
            <p class="mb-0">
                <span class="font-weight-bold">Date Hired: </span
                >{{ therapist.hired_at ? moment(therapist.hired_at).format("MM/DD/YYYY") : "" }}
            </p>
            <p class="mb-0">
                <span class="font-weight-bold">Date Terminated: </span
                >{{
                    therapist.terminated_at
                        ? moment(therapist.terminated_at).format("MM/DD/YYYY")
                        : ""
                }}
            </p>
        </div>

        <modal-component
            :id="'clinic-information'"
            :title="modal.title"
            :visible="modal.visible"
            @close="resetModal()"
        >
            <form class="p-3">
                <div class="form-group row">
                    <label for="title" class="col-6 mb-1">Title:</label>
                    <div class="col-6">
                        <select
                            :disabled="!canEditTherapist"
                            v-model="therapist_.therapist_type_ids"
                            id="title"
                            class="form-control form-control-sm"
                            required
                        >
                            <option selected disabled :value="[]">Choose one</option>
                            <option v-for="t in therapistTypes" :value="[t.id]">{{
                                t.title
                            }}</option>
                        </select>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="npi_number" class="col-6 mb-1">Employee number:</label>
                    <div class="col-6">
                        <input
                            id="employee_number"
                            type="text"
                            class="form-control form-control-sm"
                            v-model="therapist_.employee_number"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label for="npi_number" class="col-6 mb-1">NPI number:</label>
                    <div class="col-6">
                        <input
                            id="npi_number"
                            type="text"
                            class="form-control form-control-sm"
                            v-model="therapist_.npi_number"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label for="title" class="col-6 mb-1">Supervisor:</label>
                    <div class="col-6">
                        <select
                            :disabled="!canEditTherapist"
                            v-model="therapist_.supervisor_user_id"
                            id="supervisor"
                            class="form-control form-control-sm"
                            required
                        >
                            <option :value="null">None</option>
                            <option v-for="u in supervisors" :value="u.id">{{ u.name }}</option>
                        </select>
                    </div>
                </div>
                <div class="form-group row">
                    <label for="title" class="col-6 mb-1">Date Hired:</label>
                    <div class="col-6">
                        <template v-if="canEditTherapist">
                            <v-date-picker
                                class="form-control form-control-sm"
                                v-model="therapist_.hired_at"
                            ></v-date-picker>
                        </template>
                        <input
                            v-else=""
                            disabled
                            :value="moment(therapist_.hired_at).format('MM-DD-YY')"
                            type="text"
                            class="form-control form-control-sm"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <label for="title" class="col-6 mb-1">Date Terminated:</label>
                    <div class="col-6">
                        <template v-if="canEditTherapist">
                            <v-date-picker
                                class="form-control form-control-sm"
                                v-model="therapist_.terminated_at"
                            ></v-date-picker>
                        </template>
                        <input
                            v-else=""
                            disabled
                            :value="moment(therapist_.terminated_at).format('MM-DD-YY')"
                            type="text"
                            class="form-control form-control-sm"
                        />
                    </div>
                </div>
                <div class="d-flex justify-content-end">
                    <button
                        class="btn btn-sm btn-primary text-white"
                        @click.prevent="saveProfile()"
                    >
                        Save
                    </button>
                </div>
            </form>
            <errors :errors="errors"></errors>
        </modal-component>
    </section>
</template>
<script>
import ModalComponent from "../ui/ModalComponent";
import { permissions } from "../../plugins/permissions";
import { errors } from "../../plugins/errors";

export default {
    name: "TherapistClinicInformation",
    props: [
        "organization",
        "canEditTherapist",
        "person",
        "therapist",
        "id",
        "therapistTypes",
        "supervisors",
    ],
    mixins: [permissions, errors],
    components: { ModalComponent },
    data() {
        return {
            modal: {
                visible: false,
                title: "Edit Clinic Information",
            },
            therapist_: {
                therapist_type_ids: [],
                employee_number: null,
                npi_number: null,
                hired_at: null,
                terminated_at: null,
            },
        };
    },
    watch: {
        "modal.visible"() {
            if (this.modal.visible) {
                this.therapist_.supervisor_user_id = _.get(
                    this.therapist,
                    "supervisor_user.id",
                    null
                );
                this.therapist_.therapist_type_ids = [
                    _.get(this.therapist, "therapist_types.0.id", null),
                ];
                this.therapist_.employee_number = this.therapist.employee_number;
                this.therapist_.npi_number = this.therapist.npi_number;
                this.therapist_.hired_at = this.therapist.hired_at
                    ? new Date(this.therapist.hired_at)
                    : null;
                this.therapist_.terminated_at = this.therapist.terminated_at
                    ? new Date(this.therapist.terminated_at)
                    : null;
            }
        },
    },
    methods: {
        editProfile() {
            this.modal.visible = true;
        },

        resetModal() {
            this.modal.visible = false;
            this.therapist_ = {
                therapist_type_ids: [],
                employee_number: null,
                npi_number: null,
                hired_at: null,
                terminated_at: null,
            };
            this.setErrors();
        },

        saveProfile() {
            this.setErrors();
            if (this.canEditTherapist) {
                let therapist = { ...this.therapist_ };
                therapist.hired_at = therapist.hired_at
                    ? this.moment(therapist.hired_at).format("YYYY-MM-DD")
                    : null;
                therapist.terminated_at = therapist.terminated_at
                    ? this.moment(therapist.terminated_at).format("YYYY-MM-DD")
                    : null;
                axios
                    .patch(
                        `/api/organizations/${this.organization.id}/therapists/${
                            this.therapist.id
                        }`,
                        therapist
                    )
                    .then(r => {
                        this.resetModal();
                        this.$emit("data-saved");
                    })
                    .catch(e => {
                        console.error(e);
                        this.setErrors(_.get(e, "response.data.errors", {}));
                    });
            }
        },

        cleanEmptyProperties(payload) {
            Object.keys(payload).forEach(k => {
                if (!(payload[k] === 0) && !payload[k]) {
                    delete payload[k];
                }
            });
            return payload;
        },
    },
};
</script>

<style scoped></style>
